import { render, staticRenderFns } from "./ChatId.vue?vue&type=template&id=3925fd4a"
import script from "./ChatId.vue?vue&type=script&lang=js"
export * from "./ChatId.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports